import React, { Component } from "react";
import { Text, View, TouchableOpacity, StyleSheet } from "react-native";
import { FontAwesome } from "@expo/vector-icons";

class ComplianceCalendarList extends Component {
  state = {
    calendar_events: [
      {
        id: 0,
        name: "Security Awareness Training",
        day: "2023-02-01",
      },
      {
        id: 1,
        name: "Availability - post mortems",
        day: "2023-02-12",
      },
      {
        id: 2,
        name: "Process Integrity - review architecture",
        day: "2023-02-22",
      },
      {
        id: 3,
        name: "Confidentiality - review SOC2 controls",
        day: "2023-02-25",
      },
      {
        id: 4,
        name: "Privacy - Annual Review of Privacy Statement / Terms and Conditions",
        day: "2023-02-28",
      },
    ],
  };
  alertItemName = (item) => {
    alert(item.name);
  };
  render() {
    return (
      <View style={styles.container}>
        {this.state.calendar_events.map((item, index) => (
          <TouchableOpacity
            key={item.id}
            style={styles.calendar_events_list}
            onPress={() => this.alertItemName(item)}
          >
            <FontAwesome name="calendar" />
            <Text style={styles.text}>
              {item.day} - {item.name}
            </Text>
            {/* <Divider style={{ backgroundColor: "blue" }} /> */}
          </TouchableOpacity>
        ))}
      </View>
    );
  }
}
export default ComplianceCalendarList;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: "5%",
    marginTop: 20,
    margin: 0,
    backgroundColor: "white",
    alignItems: "flex-start",
    flexDirection: "column",
  },
  calendar_events_list: {
    flex: 1,
    // alignItems: "center",
    // justifyContent: "center",
  },
  text: {
    color: "#4f603c",
  },
});
